import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import { FaArrowLeft, FaTrash } from 'react-icons/fa';

function PumpProductionProcessView() {
    const { id, pointindex } = useParams();
    const navigate = useNavigate();
    const [record, setRecord] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}productionProcessPump/byproduction/${id}`, {
                    headers: authHeader(),
                });

                const data = Array.isArray(res.data) ? res.data[0] : null;
                setRecord(data);
            } catch (err) {
                console.error('Error fetching data', err);
            }
        };

        fetchData();
    }, [id]);

    const handleDelete = async () => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        });

        if (confirm.isConfirmed) {
            try {
                await axios.delete(`${BASE_URL}productionprocess/${id}`, {
                    headers: authHeader(),
                });

                Swal.fire('Deleted!', 'Data has been deleted.', 'success').then(() => {
                    navigate('/pump-production-process-list/1');
                });
            } catch (error) {
                console.error("Error deleting data", error);
                Swal.fire('Error!', 'Failed to delete.', 'error');
            }
        }
    };

    const getStatusWithIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'pending':
                return '❌ Pending';
            case 'completed':
                return '✅ Completed';
            case 'inprogress':
            case 'in progress':
                return '🟡 In Progress';
            case 'accepted':
                return '✅ Accepted';
            case 'rejected':
                return '❌ Rejected';
            default:
                return status || '—';
        }
    };

    if (!record) return <div className="text-center p-4">Loading or no data found...</div>;

    return (
        <Card className="shadow-sm border-0">
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className="fw-bold text-primary mb-0">Pump Production Process - View</h6>
                <div className="d-flex gap-2">
                    <Link to="/pump-production-process-list/1">
                        <Button variant="outline-secondary" size="sm">
                            <FaArrowLeft className="me-2" /> Back
                        </Button>
                    </Link>
                    <Link to={`/pump-production-process-update/${id}/${pointindex}`}>
                        <Button variant="warning" size="sm">✏️ Update</Button>
                    </Link>
                    <Button variant="danger" size="sm" onClick={handleDelete}>
                        <FaTrash className="me-2" /> Delete
                    </Button>
                </div>
            </Card.Header>

            <Card.Body className="px-4">
                <section className="mb-4">
                    <h6 className="text-muted fw-semibold border-bottom pb-1 mb-3">Stages-Status</h6>

                    {/* Rough Machining */}
                    <Row className="mb-2">
                        <Col md={6}><strong>Rough Machining:</strong> {getStatusWithIcon(record.roughmachine)}</Col>
                        <Col md={6}><strong>Date:</strong> {record.roughmachinedate || '—'}</Col>
                    </Row>
                    <hr />

                    {/* Fabrication */}
                    <Row className="mb-2">
                        <Col md={6}><strong>Fabrication:</strong> {getStatusWithIcon(record.fabrication)}</Col>
                        <Col md={6}><strong>Date:</strong> {record.fabricationdate || '—'}</Col>
                    </Row>
                    <hr />

                    {/* Final Machining */}
                    <Row className="mb-2">
                        <Col md={6}><strong>Final Machining:</strong> {getStatusWithIcon(record.finalmachining)}</Col>
                        <Col md={6}><strong>Date:</strong> {record.finalmachiningdate || '—'}</Col>
                    </Row>
                    <hr />
                </section>

                <section className="mb-4">
                    <h6 className="text-muted fw-semibold border-bottom pb-1 mb-3">Inspection</h6>
                    <Row className="mb-3">
                        <Col md={4}><strong>Status:</strong> {getStatusWithIcon(record.acceptorreject)}</Col>
                        <Col md={8}><strong>Rejection Reason:</strong> {record.rejectionreason || '—'}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}><strong>Inspected By:</strong> {record.inspectedbyone || '—'}</Col>
                        <Col md={6}><strong>Date:</strong> {record.inspectiondateone || '—'}</Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <Col md={6}><strong>Inspected By:</strong> {record.inspectedbytwo || '—'}</Col>
                        <Col md={6}><strong>Date:</strong> {record.inspectiondatetwo || '—'}</Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <Col md={6}><strong>Inspected By:</strong> {record.inspectedbythree || '—'}</Col>
                        <Col md={6}><strong>Date:</strong> {record.inspectiondatethree || '—'}</Col>
                    </Row>
                </section>

                <section>
                    <h6 className="text-muted fw-semibold border-bottom pb-1 mb-2">Remarks</h6>
                    <div className="bg-light p-3 rounded border">{record.remarks || '—'}</div>
                </section>
            </Card.Body>
        </Card>
    );
}

export default PumpProductionProcessView;
